import { render } from "./MfittBookingTimeoutPage.vue?vue&type=template&id=4c824751"
import script from "./MfittBookingTimeoutPage.vue?vue&type=script&lang=js"
export * from "./MfittBookingTimeoutPage.vue?vue&type=script&lang=js"
script.render = render

export default script